import React from 'react';
import Classes from 'classnames';

export default function SystemFieldTaskTypeViewInImport(props) {

    const taskType = gd.session.taskTypes.get(props.value);

    return (
        <div className={Classes("ui5-pill-22 gray")}>{taskType.name}</div>
    );
}